export const niveisEscolares = [
  { value: 'fundamental_1', label: 'Fundamental I', desc: '1º ao 5º ano' },
  { value: 'fundamental_2', label: 'Fundamental II', desc: '6º ao 9º ano' },
  { value: 'ensino_medio', label: 'Ensino Médio', desc: '1º ao 3º ano' },
  { value: 'pre_vestibular', label: 'Pré-vestibular / ENEM', desc: 'Preparação para vestibular' },
  { value: 'ensino_superior', label: 'Ensino Superior', desc: 'Graduação' },
  { value: 'eja', label: 'EJA', desc: 'Educação de Jovens e Adultos' },
  { value: 'estudo_livre', label: 'Estudo livre', desc: 'Sem vínculo escolar' }
]

export const objetivosEstudo = [
  { value: 'reforco', label: 'Reforço escolar', desc: 'Complementar as aulas da escola' },
  { value: 'prova', label: 'Preparação para prova', desc: 'Estudar para avaliações escolares' },
  { value: 'enem', label: 'ENEM / Vestibular', desc: 'Preparação intensiva' },
  { value: 'concurso', label: 'Concurso público', desc: 'Estudo para concursos' },
  { value: 'curiosidade', label: 'Curiosidade', desc: 'Aprender por interesse pessoal' },
  { value: 'autonomo', label: 'Estudo autônomo', desc: 'Organizar uma rotina própria de aprendizagem' }
]
